import { render, staticRenderFns } from "./RequestHistories.vue?vue&type=template&id=a446c072&"
import script from "./RequestHistories.vue?vue&type=script&lang=js&"
export * from "./RequestHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports